/**
 * there isn't enough going on in here to write unit tests for at this time
 */

import axios, { AxiosRequestConfig } from 'axios'
import { NODE_ENV, REACT_APP_BACK_END_URL } from 'config'

const config: AxiosRequestConfig = { withCredentials: true }

if (NODE_ENV === 'production') config.baseURL = REACT_APP_BACK_END_URL

/**
 * the axios instance needed to interface with `/api`
 */
export const rest = axios.create(config)
